/* global axios */
import ApiClient from '../ApiClient';

// Notas do ticket (T-232): as notas internas daquele atendimento, reunidas para o painel.
// Não é tabela nova, é a mensagem privada que já existe (ver notas_controller.rb).
class NotasAPI extends ApiClient {
  constructor() {
    super('fandata/conversations', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(`${this.url}/${conversationId}/notas`);
  }
}

export default new NotasAPI();
